import select from './select';
export default function sum(iterable, selector) {
    let result = 0;
    for (const item of select(iterable, selector)) {
        result += item;
    }
    return result;
}
